import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from '../log/log.service';

@Pipe({
  name: 'paymentStatus'
})
export class PaymentStatusPipe implements PipeTransform {

  constructor(private translateService: TranslateService,
              private logService: LogService) {
  }

  transform(value: string, args?: any): any {

    // Pipes need to handle nulls/undefined
    if (!value) {
      value = '';
    }

    value = value.toLowerCase().toString();

    let returnValue = '';

    switch (value) {
      case 'ready':
        returnValue = this.translateService.instant('PAYMENT_STATUS.READY');
        break;
      case 'pending':
        returnValue = this.translateService.instant('PAYMENT_STATUS.PENDING');
        break;
      case 'invoiced':
        returnValue = this.translateService.instant('PAYMENT_STATUS.INVOICED');
        break;
      case 'invoice-rejected':
        returnValue = this.translateService.instant('PAYMENT_STATUS.INVOICE_REJECTED');
        break;
      case 'funded':
        returnValue = this.translateService.instant('PAYMENT_STATUS.FUNDED');
        break;
      case 'pay-sent':
        returnValue = this.translateService.instant('PAYMENT_STATUS.PAY_SENT');
        break;
      case 'pay-rejected':
        returnValue = this.translateService.instant('PAYMENT_STATUS.PAY_REJECTED');
        break;
      case 'requested':
        returnValue = this.translateService.instant('PAYMENT_STATUS.REQUESTED');
        break;
      case 'request-rejected':
        returnValue = this.translateService.instant('PAYMENT_STATUS.REQUEST_REJECTED');
        break;
      case 'resent-request':
        returnValue = this.translateService.instant('PAYMENT_STATUS.RESENT_REQUEST');
        break;
      case 'paid-direct':
        returnValue = this.translateService.instant('PAYMENT_STATUS.PAID_DIRECT');
        break;
      case 'cancelled':
        returnValue = this.translateService.instant('PAYMENT_STATUS.CANCELLED');
        break;
      case 'error':
        returnValue = this.translateService.instant('PAYMENT_STATUS.ERROR');
        break;
      default:
        this.logService.info(this.translateService.instant('PAYMENT_STATUS.UNKNOWN', { key: value }));
    }

    return returnValue;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/pipes/payment-status.pipe.ts